import React, { useState } from "react"
import clsx from "clsx"
import { useCustomName } from "hooks"
import { useFormSubmissionReportExportContext } from "contexts/FormSubmissionReportExportContext"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import LocationAnswerFiltersLocationDetailsFacilitySelect from "./LocationAnswerFiltersLocationDetailsFacilitySelect"
import LocationAnswerFiltersLocationDetailsSelectedFacilities from "./LocationAnswerFiltersLocationDetailsSelectedFacilities"

const LocationAnswerFiltersLocationDetails = () => {
  const {
    addAllFacilityDepartmentsToLocationAnswerFilters,
    removeAllFacilityDepartmentsFromLocationAnswerFilters,
  } = useFormSubmissionReportExportContext()

  const [selectedFacilityIds, setSelectedFacilityIds] = useState([])

  const { pluralName: departmentsName } = useCustomName(DEPARTMENT_KEY)

  const updateSelectedFacilities = (facilityIds) => {
    const currentSelectedFacilityIds = selectedFacilityIds

    const facilityIdsToAdd = facilityIds.filter((id) => !currentSelectedFacilityIds.includes(id))
    facilityIdsToAdd.forEach(addAllFacilityDepartmentsToLocationAnswerFilters)

    const facilityIdsToRemove = currentSelectedFacilityIds.filter((id) => !facilityIds.includes(id))
    facilityIdsToRemove.forEach(removeAllFacilityDepartmentsFromLocationAnswerFilters)

    setSelectedFacilityIds(facilityIds)
  }

  return (
    <>
      <LocationAnswerFiltersLocationDetailsFacilitySelect
        className={clsx(selectedFacilityIds.length > 0 && "mb-4")}
        onChange={updateSelectedFacilities}
        values={selectedFacilityIds}
      />
      {
        selectedFacilityIds.length > 0 && (
          <div>
            <span className="block mb-4">{departmentsName}:</span>
            <LocationAnswerFiltersLocationDetailsSelectedFacilities selectedFacilityIds={selectedFacilityIds} />
          </div>
        )
      }
    </>
  )
}

export default LocationAnswerFiltersLocationDetails
